import { environment } from "../../../../environments/environment";

/**
 * Path prefixes that `npm run start:local-ai` serves from this machine instead
 * of the dev gateway (WWP-41): the ai-service playground, the AI costs and the
 * labels, which carry the new keys before they are published.
 */
const LOCAL_AI_PREFIXES = ["/ai-playground", "/gemini-usage", "/labels"];

/**
 * Base url for the calls to a gateway path.
 *
 * In every build it is `environment.apiGatewayUrl`. Only in the local-ai
 * configuration the prefixes above become relative urls, which the dev server
 * proxy (proxy.ai-local.conf.js) sends to the services running locally, while
 * everything else, login included, keeps going to dev.
 *
 * @param prefix gateway path prefix, e.g. "/labels"
 * @returns the url to prepend to the prefix
 */
export const gatewayBaseUrl = (prefix: string): string =>
  environment.localAiProxy && LOCAL_AI_PREFIXES.includes(prefix)
    ? ""
    : environment.apiGatewayUrl;
